const csrfToken = document.head.querySelector("[name='csrf-token']").attributes.content.value;
const CSRFHeaders = () => ({
  "Content-Type": "application/json",
  Accept: "application/json",
  "X-Requested-With": "XMLHttpRequest",
  "X-CSRF-Token": csrfToken,
});
 
export default CSRFHeaders;
